import { Card } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import NewDisciplineChangeRequestApiService from '../../../../api/NewDisciplineChangeRequestApiService';
import ChangeRequestSubmitted from '../../../../components/displays/postSecondary/ChangeRequestSubmitted';
import Breadcrumbs from '../../../../config/Breadcrumbs';
import Routes from '../../../../config/Routes';
import * as GetNewDisciplineChangeRequestHandler from '../../../../handlerModels/GetNewDisciplineChangeRequestHandler';
import ChangeRequestDTO from '../../../../models/ChangeRequestDTO';
import UserSecurity from '../../../../models/UserSecurity';
import HeaderPortal from '../../../../portals/HeaderPortal';
import BaseFormState from '../../../../redux/bases/BaseFormState';
import { StateStoreModel } from '../../../../redux/state/StateStoreModel';
import Guid from '../../../../utils/Guid';
import HistoryUtil from '../../../../utils/HistoryUtil';
import ParameterUtil from '../../../../utils/ParameterUtil';

interface NewDisciplineChangeRequestReviewPageState extends BaseFormState {
  changeRequestId: string;
  changeRequest: ChangeRequestDTO;
  progress: number;
}

interface NewDisciplineChangeRequestReviewPageProps {
  currentUser: UserSecurity | null;
}

class NewDisciplineChangeRequestReviewPage extends React.Component<NewDisciplineChangeRequestReviewPageProps & RouteComponentProps<RouteObject>, NewDisciplineChangeRequestReviewPageState> {
  constructor(props: NewDisciplineChangeRequestReviewPageProps & RouteComponentProps<RouteObject>) {
    super(props);

    this.state = {
      changeRequestId: Guid.Empty(),
      changeRequest: ChangeRequestDTO.create(),
      progress: 0
    };
  }

  componentDidMount() {
    const id = ParameterUtil.getPathPart(this.props.match, 'id');

    if (id !== Guid.Empty() && this.state.changeRequestId != id) {
      this.setState({ changeRequestId: id });
      this.fetchData(id);
    }
  }

  private fetchData = (id: string) => {
    this.setState({ loading: true });

    const loaders = [];

    if (id !== Guid.Empty()) {
      loaders.push(this.loadChangeRequest(id));
    }

    Promise.all(loaders).then(() => {
      this.setState({ loading: false });
    });
  }

  private loadChangeRequest = (id: string) => {
    const request = GetNewDisciplineChangeRequestHandler.Request.create({
      changeRequestId: id
    });

    return NewDisciplineChangeRequestApiService.get(request)
      .then((results: GetNewDisciplineChangeRequestHandler.Result) => {
        if (results) {
          this.setState({
            changeRequest: results.changeRequest ?? ChangeRequestDTO.create(),
          });
        }
      }).catch(() => {
        this.setState({ error: true, message: 'Could not load change request.' });
      });
  }

  goToPreviousStep = () => {
    HistoryUtil.push(Routes.generate(Routes.EXISTING_NEW_DISCIPLINE_CHANGE_REQUEST_ENTRY_2, { id: this.state.changeRequestId }, {}))
  }

  submit = () => {
    HistoryUtil.push(Routes.generate(Routes.EXISTING_NEW_DISCIPLINE_CHANGE_REQUEST_ENTRY_SUBMITTED, { id: this.state.changeRequestId }, {}))
  }

  render() {
    return (
      <Content >
        <HeaderPortal
          breadcrumbs={Breadcrumbs.changeRequestList()} >
        </HeaderPortal>

        <Card >
          <ChangeRequestSubmitted />
        </Card>
      </Content >
    );
  }
}

function mapStateToProps(state: StateStoreModel) {
  return {
    currentUser: state.UserSession.Value,
  };
}

export default withRouter(connect(mapStateToProps)(NewDisciplineChangeRequestReviewPage));